<template>
  <div>
    <v-select
      v-if="label === 'Celular' && isInternacionalModuleActive"
      ref="ddi"
      v-model="selectCountryLocal"
      class="col-30 pr-0 input input-cpf allowed-countries"
      label="País"
      :items="allowedCountries"
      item-text="label"
      item-value="value"
      outlined
    >
      <template #item="{ item, attrs }">
        <v-list-item-content>
          <v-list-item-title class="country-select-item">
            <div class="align-center">
              <img class="flag" v-bind="attrs.icon" :src="require(`@/assets/${item.icon}`)" /> <span style="color: #4b525a;">{{ item.label }}</span>
            </div>
            <span style="color: #4b525a;">{{ getDDIs[item.value] }}</span>
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <template #selection="{ item, attrs }">
        <v-list-item-content>
          <v-list-item-title style="position: absolute; font-size: 25px;">
            <img class="flag" v-bind="attrs.icon" :src="require(`@/assets/${item.icon}`)" />
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-select>
    <v-text-field
      :key="inputField"
      v-model="value"
      v-validate.disable="validator"
      v-mask="sortedMasks"
      outlined
      :class="classField"
      :label="label"
      :placeholder="placeholderLocal"
      :error-messages="errors.first(field) || error"
      :name="field"
      :append-icon="getIcon"
      @blur="validateField"
    />
  </div>
</template>
<script>
import _ from 'lodash'
import { validCpf, validCnpj } from '@/config/custom-validators.js'
import { documentMaskMixin } from '@/mixins/document-mask'

export default {
  name: 'FormText',
  inject: ['$validator'],
  mixins: [documentMaskMixin],
  props: {
    id: String,
    label: String,
    width: {
      type: Number,
      default: 100
    },
    field: String,
    validator: Object,
    backend: {
      type: Array,
      default: () => []
    },
    mask: {
      default: null,
      type: Array
    },
    placeholder: {
      default: null,
      type: String
    },
    extra_data: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    error: null,
    value: '',
    inputField: 0,
    selectCountryLocal: '',
    nomask: {
      mask: '*'.repeat(255),
      tokens: {
        '*': { pattern: /./ }
      }
    },
    validId: false
  }),
  computed: {
    placeholderLocal() {
      if (this.label === 'Celular') {
        if (this.selectCountryLocal === 'ARGENTINA') {
          return '+54 99999999999'
        }
        if (this.selectCountryLocal === 'URUGUAY') {
          return '+598 99999999'
        }
        if (this.selectCountryLocal === 'BRASIL') {
          return '+55 (99) 9 9999-9999'
        }
      }
      return this.placeholder
    },
    classField() {
      if (this.isPhoneOrEmailField) {
        if (this.label === 'Celular' && this.isInternacionalModuleActive) {
          return [`col-70`, (this.errors.first(this.field) || this.error) && 'block']
        }
        return [`col-100`, (this.errors.first(this.field) || this.error) && 'block']
      }
      return [`col-${this.width || 100}`, (this.errors.first(this.field) || this.error) && 'block']
    },
    isPhoneOrEmailField() {
      return this.label === 'Celular' || this.label === 'E-mail'
    },
    sortedMasks() {
      if (!this.mask) return this.nomask
      if (this.label === 'Celular') {
        if (this.selectCountryLocal === 'ARGENTINA') {
          return ['+54 ###########']
        }
        if (this.selectCountryLocal === 'URUGUAY') {
          return ['+598 ###########']
        }
        if (this.selectCountryLocal === 'BRASIL') {
          return ['+55 (##) ####-#####', '+55 (##) # ####-####']
        }
      }
      const mask = _.cloneDeep(this.mask)
      mask.sort((a, b) => (a.length > b.length ? 1 : -1))
      return mask
    },
    componentValue() {
      const obj = { [this.field]: this.value }
      return this.extra_data ? { extra_data: obj } : obj
    },
    isValidField() {
      return this.fields[this.field].valid
    },
    accountId() {
      return this.$store.getters.GET_ACCOUNT_ID
    },
    loadingId() {
      return this.$store.getters.LOADING_ID
    },
    getIcon() {
      if (this.field === 'email') {
        if (this.loadingId) return 'fas fa-circle-notch fa-spin'
        if (this.field === 'email' && this.validId) return 'fas fa fa-check'
      }
      return ''
    },
    isLogged() {
      return this.$store.getters.TOKEN
    },
    userCurrentEmail() {
      return this.$store.getters.USER_INFO.email
    },
    getDDIs() {
      return {
        BRASIL: '+55',
        ARGENTINA: '+54',
        URUGUAY: '+598'
      }
    },
    getDdiUser() {
      return {
        '55': 'BRASIL',
        '54': 'ARGENTINA',
        '598': 'URUGUAY'
      }
    }
  },
  watch: {
    selectCountryLocal() {
      if (this.label === 'Celular') {
        this.value = this.$store.getters.USER_INFO[this.field]
        this.forceRerenderInput()
      }
    }
  },
  mounted() {
    this.selectCountryLocal = this.$store.getters.SELECTED_COUNTRY
    if (this.$store.getters.TOKEN && this.$store.getters.USER_INFO[this.field]) {
      this.value = this.$store.getters.USER_INFO[this.field]
      if (this.label === 'Celular') {
        const user = this.$store.getters.USER_INFO
        this.selectCountryLocal = this.getDdi(user.ddi || user.phone)
      }
    }
    this.$validator.extend('validCpf', validCpf)
    this.$validator.extend('validCnpj', validCnpj)
  },
  methods: {
    getDdi(value) {
      const [brazilDdi, uruguayDdi, argentinaDdi] = ['55', '598', '54']
      if (!value) return ''

      if (value.startsWith(brazilDdi)) return 'BRASIL'
      if (value.startsWith(uruguayDdi)) return 'URUGUAY'
      if (value.startsWith(argentinaDdi)) return 'ARGENTINA'

      return 'BRASIL'
    },
    forceRerenderInput() {
      this.inputField += 1
    },
    validateField() {
      this.$validator.validate(this.field, this.value).then(valid => {
        if (this.field === 'email' && this.isLogged && this.userCurrentEmail) {
          if (!this.value) {
            this.error = 'Esse campo precisa ter um e-mail válido.'
            this.validId = false
            return
          }
          this.checkUniqueEmail(this.value)
          return
        }
        if (valid) {
          if (this.backend !== null && this.backend.length > 0) {
            this.backend.map(method => {
              if (this.value.length > 0) this[method](this.value)
              this.validId = false
            })
          }
        } else {
          this.validId = false
        }
      })
    },
    async checkUniqueEmail(email) {
      if (this.isLogged && this.userCurrentEmail === email) {
        this.error = null
        this.validId = true
        return
      }
      await this.$store
        .dispatch('checkUniqueUser', { email: email })
        .then(response => {
          if (response.user_exists) {
            this.error = 'Já existe um cadastro utilizando esse e-mail.'
            this.validId = false
          } else {
            this.error = null
            this.validId = true
          }
        })
        .catch(error => {
          if (error.response && error.response.errors && error.response.errors[0] && error.response.errors[0].message === 'invalid.email') {
            this.error = 'Esse campo precisa ter um e-mail válido.'
            this.validId = false
          } else if (
            error.response &&
            error.response.errors &&
            error.response.errors[0] &&
            error.response.errors[0].message === 'Multiple users exist with this email/document_no combination'
          ) {
            this.error = 'Já existe um cadastro utilizando esse e-mail.'
            this.validId = false
          }
        })
    },
    validateEmail() {
      // note: this is called at CadastroPadrao.vue
      if (this.isLogged && this.userCurrentEmail === this.value) return true
      return this.validId
    }
  }
}
</script>
<style lang="scss">
.v-icon.fa-check {
  color: lightseagreen !important;
}
</style>

<style lang="scss" scoped>
.country-select-item {
  justify-content: space-between;

  div {
    display: flex;
    gap: 8px;
  }
}
</style>
